/*
 * WW-508 Trade Services Catalog Load - Phase 3: Restrict Search results, Supplier visibility, 
 * and Item add to Cart based on Walmart business rules - Deepthi N H
 */
import React, { Component } from 'react';
import * as $ from 'jquery';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next';
import * as OrderEntryAction from '../actions/OrderEntryAction';
import OrderEntryStore from '../stores/OrderEntryStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as MenuAction from '../actions/MenuAction';
//WW-1216 Precart ratings and reviews - Yuvarani K
import * as App from '../App';
import Rating from 'material-ui-rating'
import Copy from 'copy-to-clipboard';
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import * as SupplierSuggestionAction from '../actions/SupplierSuggestionAction';
import SupplierSuggestionStore from '../stores/SupplierSuggestionStore';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import SearchResultsStore from '../stores/SearchResultsStore';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
import Autocomplete from 'react-autocomplete';
import ItemDetailNewStore from '../stores/ItemDetailNewStore';
import * as ItemDetailNewAction from '../actions/ItemDetailNewAction';
import swal from 'sweetalert';
import { lineHeight } from '@material-ui/system';
let currentPagePath;
let QuantityValue;
let IsFromFavClick = "";
let FromPageName = "";
let LongDesc = "";
let EnersysItems = "";
let FormItems = "";
let ItemID = "";
let Vendor_ID = "";
//[1/20/23, PC_WW-552_FE_40, Dhevanesam R]
let FormFilePath = "";
let SearchKey = "";
let WorkOrder = "";
let rmvAttachindex = -1;
let SupplierName = "";
let MFGName = "";
let Qty = "";
let MFGPartNo = "";
let FormDataProps = [];
let FormOptionsDataProps = [];
let IsAltPart = ""
let IsPickup = false
let IsImageSearch = false
let ImageFiles = ""
let image = ""
let cartDelete = false; 
//WW-1216 Precart ratings and reviews - Yuvarani K
let SuppllierGridArray = []
let ReasonArray
let ReasonList = [];
let ItemDetail = [];
let isSubmitDisabled = false;
let ReasonSelect = false;
let ItemDetails = [];
let ReasonType = ""
let FavItem = false;



class SupplierSuggestionComponent extends Component {
    _isMounted = false;
    /**
  * 
  * Define the constructor that takes props as parameter
  * 
  * @param props
  */
    constructor(props) {
        super(props);

        this.state = {
            Login_UserId: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
            Login_UserBU: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            SupllierGridArray: [], AddIndex: 0, EnersysFormVaue: "", EnersysForm: false,
            DoorFormValue: "",
            ItemType: "", autocompleteDataRstl: [], FavYourCatg: "", FiltItemValue: {}, FiltItemIndex: 0,
            lblerror: "", txtUOMHidePopUp: "", txtMfgItemidHidePopUp: "",
            txtItemidHidePopUp: "", txtMFGHidePopUp: "",
            FavItemIdPopUp: "", FavSDICatgPopUp: "", autocompleteDataRstl: [], FavItemImage: "", FavItemKitComponent: "", FavKit_Components: "", IsFromFav: false,
            FavYourCatg: "", autocompleteData: [], CategoryErr: false, SelectedValueImg: "", attachmentPathArr: [], attachmentErrormsg: "", FavoritesSubMenu: [], AddValue: [], FormData: "", FormOptionsData: "",
            AddToCartIndex: "", AddToCartValue: {}, //WW-694_PC_01 -Aparna
            //WW-1216 Precart ratings and reviews - Yuvarani K
            IsRatingPopup: false,
            IsRateNow: true,
            StarRating: 0,
            //ReasonSelect: false,
            RatingCount: 0,
            Review: "",
            IsReasonPopup: false,
            Comments: "",
            ItemDetails: [], currentItemIndex: 0, ReasonType: "", Comments: "", ReasonArray: [], ReasonList: [],
            ProductRating: 4.2, RatingCount: "(1.2k)", FavItem: false, ItemTypeFav: "", FavItemIdPopUp: "",



        };
        //WW-1216 Precart ratings and reviews - Yuvarani K
        SuppllierGridArray = CookieService.getLocalStorageValues("SuggestedSupplierList")
         //cartDelete = false; /
        //FavItem = CookieService.getLocalStorageValues("Search_ItemFav")
    };

    //SS_PC_01 - WW-508 Trade Services Catalog Load - Phase 3 - Deepthi N H
    componentDidMount = () => {
       
        const queryParams = new URLSearchParams(window.location.search);
        //Pass the Values in Props as we are getting Exception when we pass spl character in query string-Priyanka-INC0013356
        MFGPartNo = this.props.location.state.ManufacturePartNumber
        MFGName = this.props.location.state.ManufactureName
        IsFromFavClick = this.props.location.state.IsFromFav
        FromPageName = this.props.location.state.FavItemPage
        LongDesc = this.props.location.state.longDesc
        SearchKey = this.props.location.state.SearchKey
        SupplierName = this.props.location.state.Suppliername
        Qty = this.props.location.state.qtyadj
        IsAltPart = this.props.location.state.IsAltPart
        IsPickup = this.props.location.state.IsPickup
        IsImageSearch = this.props.location.state.IsImageSearch
        ImageFiles = this.props.location.state.ImageFiles
        cartDelete = this.props.location.state.cartDelete; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        image = this.props.location.state.ImgURL
        this.dynamicFormReponse = this.dynamicFormReponse.bind(this)
        FavItem = CookieService.getLocalStorageValues("Search_ItemFav")
        //MFGPartNo = queryParams.get('ManufacturePartNumber');
        //MFGName = queryParams.get('ManufactureName');
        //IsFromFavClick = queryParams.get('IsFromFav');
        //FromPageName = queryParams.get('FavItemPage');
        //LongDesc = queryParams.get('longDesc');
        //SearchKey = queryParams.get('SearchKey');
        //SupplierName = queryParams.get('Suppliername');
        //Qty = queryParams.get('qtyadj');

        EnersysItems = "";
        //if (FromPageName == "ItemDetailFromFav" || FromPageName == "ItemDetailFromCart") {
        //    this.GetSupplierList(MFGPartNo);
        //}
        //else {
        //    let Supplierlist = CookieService.getLocalStorageValues("SuggestedSupplierList");
        //    if (Supplierlist != undefined && Supplierlist != null) {
        //        if (Supplierlist.length > 0) {
        //            this.DirectSuggestion();
        //        }
        //        else {
        //            this.GetSupplierList(MFGPartNo);
        //        }
        //    }
        //    else {
        //        this.GetSupplierList(MFGPartNo);
        //    }
        //}
        this.GetSupplierList(MFGPartNo);

        SupplierSuggestionStore.on('TsSearchresult', this.SupplierListReponse);
        SupplierSuggestionStore.on('DynamicForm', this.dynamicFormReponse);
        SupplierSuggestionStore.on('SupplierStatus', this.CoreChargeResponseClick);
        NonCatalogStore.on('attachmentResponse', this.loadAttachments);
        NonCatalogStore.on('rmvAttach', this.removeAttachmentResponse);
        // WW-1216 Precart ratings and reviews - Yuvarani K
        SupplierSuggestionStore.on('RatingResponse', this.RatingResponse);


    };
    //WW-1216 Precart ratings and reviews - Yuvarani K

    getStarImage = (Rating) => {

        const roundedRating = Math.round(Rating * 2) / 2;
        const clampedRating = Math.min(Math.max(roundedRating, 0), 5);
        const ratingString = clampedRating.toFixed(1);
        const imageMap = {
            '0.0': 'Images/0-star.svg',
            '0.5': 'Images/0.5-star.svg',
            '1.0': 'Images/1-star.svg',
            '1.5': 'Images/1.5-star.svg',
            '2.0': 'Images/2-star.svg',
            '2.5': 'Images/2.5-star.svg',
            '3.0': 'Images/3-star.svg',
            '3.5': 'Images/3.5-star.svg',
            '4.0': 'Images/4-star.svg',
            '4.5': 'Images/4.5-star.svg',
            '5.0': 'Images/5-star.svg'
        };

        return imageMap[ratingString];
    }
    //WW-1216 Precart - Yuvarani K

    componentWillUnmount = () => {
        SupplierSuggestionStore.removeListener('TsSearchresult', this.SupplierListReponse.bind(this));
        SupplierSuggestionStore.removeListener('DynamicForm', this.dynamicFormReponse);
        SupplierSuggestionStore.removeListener('SupplierStatus', this.CoreChargeResponseClick.bind(this));
        NonCatalogStore.removeListener('attachmentResponse', this.loadAttachments);
        NonCatalogStore.removeListener('rmvAttach', this.removeAttachmentResponse);
        //WW-1216 Precart ratings and reviews - Yuvarani K
        SupplierSuggestionStore.removeListener('RatingResponse', this.RatingResponse);

    };
    handleEditQuantity = (e, index, value) => {
        let val = e.target.value;
        let QtyToBeChanged = 0;
        let AdjQtySupplierArray = SuppllierGridArray;
        if (val.length > 5) {
            return;
        }
        if ((parseInt(val) % parseInt(AdjQtySupplierArray[index].min_order_qty)) != 0 || val == 0) {
            AdjQtySupplierArray[index].minOrderQtyCheck = true
        }
        else {
            AdjQtySupplierArray[index].minOrderQtyCheck = false
        }

        let re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            if (e.target.value == 0 || e.target.value == '0') {
                QtyToBeChanged = AdjQtySupplierArray[index].min_order_qty
            }
            else {
                QtyToBeChanged = e.target.value;
            }

            AdjQtySupplierArray[index].QuantityOrdered = QtyToBeChanged;
            SuppllierGridArray = AdjQtySupplierArray
            this.setState({ SupllierGridArray: AdjQtySupplierArray });
        }

    }




    AddfavItem = (ImgNo) => {
        
        let itemtypevalue = this.state.ItemType
        let ItemDescrip = $('#FavYourDescrip').val()
        let ItemCatagory = $('#FavYourCatg').val();
        ItemCatagory = this.state.FavYourCatg;

        if (itemtypevalue == "CAT") {
            if (ItemCatagory != null && ItemCatagory != undefined) {
                if (ItemCatagory.trim() != "") {
                    if ((!(this.state.SelectedValueImg.includes(".png") || (this.state.SelectedValueImg.includes(".PNG"))) && !(this.state.SelectedValueImg.includes(".JPEG") || (this.state.SelectedValueImg.includes(".jpeg"))) && !(this.state.SelectedValueImg.includes(".jpg") || (this.state.SelectedValueImg.includes(".JPG")))) && this.state.attachmentPathArr.length == 0 && ImgNo != true) {
                        $('#add-fav-Img').modal('show');
                        $('#add-fav-popup').modal('hide');
                        return;
                    }
                    else {
                        let FavItemBo = {
                            Session_BUSUNIT: this.state.Login_UserBU,
                            Session_USERID: this.state.Login_UserId,
                            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                            Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                            ItemId: this.state.FavItemIdPopUp,
                            YourDesc: ItemDescrip != " " && ItemDescrip != "" ? ItemDescrip.toUpperCase() : "",
                            YourCat: ItemCatagory != " " && ItemCatagory != "" ? ItemCatagory.toUpperCase() : "",
                            SDI_Catagory: this.state.FavSDICatgPopUp,
                            txtItemidHide: this.state.txtItemidHidePopUp,
                            txtMFGHide: this.state.txtMFGHidePopUp,
                            txtUOMHide: this.state.txtUOMHidePopUp,
                            txtMfgItemidHide: this.state.txtMfgItemidHidePopUp,
                            SAP: this.state.FavSAP,
                            Manufacturer: this.state.FavMFGPopUp,
                            WorkOrder: WorkOrder,
                            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",// localStorage.getItem("StoreValue") != null ? JSON.parse(localStorage.getItem("StoreValue")) : "", sending home store as dafult value for the shipto id(for warhouse item qty check sp)WAL-767-Aparna
                            ImgByteCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null),
                            IsWeb: true,
                            FileNameCode: (this.state.attachmentPathArr[0] != undefined ? this.state.attachmentPathArr[0].FilePath : null),
                        }
                        console.log("HOME_STORE", CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ")
                        //SupplierSuggestionAction.catfavItem(FavItemBo)
                        $('#add-fav-popup').modal('hide');
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        this.setState({ CategoryErr: false });
                    }

                }
                else {
                    this.setState({ CategoryErr: true });
                }
            }
            else {
                this.setState({ CategoryErr: true });
            }
        }
        else {
            if (ItemCatagory.trim() != "" && ItemCatagory != null && ItemCatagory != undefined) {
                let FavItemBo = {
                    ItemIdType: "NONCAT",
                    YourDesc: ItemDescrip,
                    YourCat: ItemCatagory,
                    Item_Description: this.state.FavItemDescripPopUp,
                    Item_MFG: this.state.FavMFGPopUp,
                    Session_BUSUNIT: this.state.Login_UserBU,
                    Session_USERID: this.state.Login_UserId,
                    MFG_PartNumber: this.state.FavMFGPartNUMPopUp,
                    img_name: this.state.FavitemImage,
                    UOM: this.state.txtUOMHidePopUp,
                    supplierId: this.state.txtMFGHidePopUp,
                    supplierPartNo: this.state.txtMfgItemidHidePopUp,
                    SAP: this.state.FavSAP,
                    WorkOrder: WorkOrder,
                    ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
                }
                SupplierSuggestionAction.NoncatfavItem(FavItemBo)
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                this.setState({ CategoryErr: false });
            }
            else {
                this.setState({ CategoryErr: true });
            }
        }
    }




    FavSuccess = () => {

        const { t } = this.props
        let Status = JSON.parse(SupplierSuggestionStore.FavitemAddList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        console.log("Status", Status)
        let Favstatus = Status.ErrorMsg
        if (Favstatus.length > 0) {
            if (Favstatus[0].Error_Msg == "Favorite item inserted sucessfully") {
                //e.preventDefault();
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Favorite item inserted sucessfully")
                });
                //  alert("Favorite item inserted sucessfully
                this.setState({ FavItem: true })
                let favsub = Status.FavSubMenu
                MenuAction.refreshMasterData()
                //WW-368_SuggestionCat_for_searchresult_PC_05 -Aparna 
                let autoCompleteDataRes = []
                let locsugg = []
                let suggestionsStr = CookieService.getLocalStorageValues("Fav_Item_Cat")
                console.log("Fav_Item_Cat", suggestionsStr)
                if (suggestionsStr != null && suggestionsStr != "" && suggestionsStr != undefined) {
                    suggestionsStr.forEach((sugg, index) => {
                        autoCompleteDataRes.push({ label: sugg.ISA_FAVS_CATEGORY, value: sugg.ISA_FAVS_CATEGORY });
                    });
                }
                this.setState({ autocompleteData: autoCompleteDataRes });
                this.setState({ FavoritesSubMenu: favsub, FavItem: true });


                if (FromPageName = "ItemDetail") {
                    this.props.history.push({
                        pathname: `\itemdetailnew`,
                        search: `?ManufacturePartNumber=${this.state.FavMFGPartNUMPopUp}`,
                        state: { IsAltPart: IsAltPart, WO: JSON.parse(localStorage.getItem("WONum")), TsItemData: this.state.FiltItemValue, Page: 'TsSupplierSugg', IsFav: true }
                    });


                }
                else {
                    window.history.go(-1);
                }


            }
            else {
                //e.stopImmediatePropagation();
                //e.preventDefault();
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Technical Issue Try again")
                });
                //  alert("Technical Issue Try again");
            }
        }
    }
    onInputClick = (event) => {
        event.target.value = ''
    }
    loadAttachments = () => {

        const { t } = this.props
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            if (!(attachmentResponse[0].FileName.toLowerCase().includes('jpg') || (attachmentResponse[0].FileName.toLowerCase().includes('png')) || (attachmentResponse[0].FileName.toLowerCase().includes('jpeg')))) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("You can choose only the Image files!!")
                });
                return;
            }
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
        } else {
            this.setState({
                attachmentErrormsg: t("You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.")
            });
        }
    };
    //WW-1216 Precart ratings and reviews - Yuvarani K


    Rating = (value) => {
        this.setState({ StarRating: value })
    }
    //WW-1216 Precart ratings and reviews - Yuvarani K
    HandleReview = (e) => {
        let value = e.target.value
      // value = value.replace(/[^a-zA-Z0-9\s]/g, '');
        this.setState({ Review: value })

    }

    //WW-1216 Precart ratings and reviews - Yuvarani K
    HandleReasonType = (e) => {
        console.log("Reason", e.value)
        ReasonType = e.value;
        this.setState({ ReasonType: e })
    }
    //WW-1216 Precart ratings and reviews - Yuvarani K
    HandleComments = (e) => {

        //12-05-2024 Precart SIT-1 bug fix - Yuvarani K
        const maxLength = 254;
        let value = e.target.value;
       //value = value.replace(/[^a-zA-Z0-9\s]/g, '');

        if (value.length > maxLength) {
            value = value.substring(0, maxLength);
        }
        this.setState({ Comments: value });
        if (this.state.ReasonType.value == "Other" && value.trim() != "") {

            ReasonSelect = true;
        }

    }


    //WW-1216 Precart ratings and reviews - Yuvarani K
    CloseReasonPopup = () => {
        $('#ReasonPopup').modal('hide');
        this.setState({ ReasonType: "", Comments: "" })
    }

    //WW-1216 Precart ratings and reviews - Yuvarani K

    RatingPopup = (e, value) => {
        ItemDetails = value
        $('#RatingPopup').modal('show');

    }

    //WW-1216 Precart ratings and reviews - Yuvarani K
    CloseRatingPopup = () => {
        //window.location.reload();
        $('#RatingPopup').modal('hide');
        this.setState({ Review: "", StarRating: 0 })

    }

    //WW-1216 Precart ratings and reviews - Yuvarani K   
    RatingResponse = () => {
        const { t } = this.props
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let response = SupplierSuggestionStore.RatingSubmissionresponse
        if (response != undefined && response != null) {
            if (response == "Inserted Successfully") {
                this.props.toastSuccessMessage(t("Thank you for your response"))
            }
            else {
                if (response == "Not Inserted") {

                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("Error in inserting the rating. Please contact SDI")
                    });
                }

            }
        }

        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Error in inserting the rating. Please contact SDI")
            });

        }
        $('#RatingPopup').modal('hide');
        // window.location.reload();

    }

    //WW-1216 Precart ratings and reviews - Yuvarani K
    RatingSubmission = (e) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //   window.location.reload();
        this.setState({ Review: "", StarRating: 0 })

        let RatingBO = {
            BU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            //Precart SIT-1 bug fix - Yuvarani K
            Vendor_id: ItemDetails.vendor_id,
            Item_id: ItemDetails.clientPartNumber,
            Employee_id: CookieService.getLocalStorageValues("Session_UserID"),
            Rating: this.state.StarRating,
            Comments: this.state.Review

        };
        SupplierSuggestionAction.RatingSubmission(RatingBO);

    }
    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = NonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            document.getElementById("lblerror").innerText = "";
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments.splice(rmvAttachindex, 1);
            this.setState({ attachmentPathArr: tempAttachments });
            rmvAttachindex = -1;
        }
    };
    removeAttachments = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.removeAttachment(removeBO);
    }
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };
    bindAttachments = () => {
        return this.state.attachmentPathArr.map((attachment, index) => {
            return (
                <span className="attachment-file-name mt-2" key={index}>
                    <a className="noncat-Attachment-overflow" data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                    <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments(attachment.FilePath, index)}>X</span>
                </span>
            );
        });
    };
    handleMinOrderQuantity = (e, index, value) => {
        let QtyToBeChanged = "";
        let AdjQtySupplierArray = SuppllierGridArray;
        AdjQtySupplierArray[index].minOrderQtyCheck = false
        if ((parseInt(AdjQtySupplierArray[index].QuantityOrdered) % parseInt(AdjQtySupplierArray[index].min_order_qty)) != 0) {
            if (parseInt(AdjQtySupplierArray[index].QuantityOrdered) < parseInt(AdjQtySupplierArray[index].min_order_qty)) {
                QtyToBeChanged = AdjQtySupplierArray[index].min_order_qty;
                AdjQtySupplierArray[index].QuantityOrdered = QtyToBeChanged;
                this.setState({ SupllierGridArray: AdjQtySupplierArray });
                SuppllierGridArray = AdjQtySupplierArray;
            }
            else if (parseInt(AdjQtySupplierArray[index].QuantityOrdered) > parseInt(AdjQtySupplierArray[index].min_order_qty)) {
                if (e.target.value == "+") {

                    let IsValidqty = false
                    let MinQty = AdjQtySupplierArray[index].min_order_qty;
                    while (!IsValidqty) {
                        if (parseInt(MinQty) < parseInt(AdjQtySupplierArray[index].QuantityOrdered)) {
                            MinQty = parseInt(MinQty) + parseInt(AdjQtySupplierArray[index].min_order_qty);
                        }
                        else if (parseInt(MinQty) > parseInt(AdjQtySupplierArray[index].QuantityOrdered)) {
                            let diff = parseInt(MinQty) - parseInt(AdjQtySupplierArray[index].QuantityOrdered);
                            if (diff <= parseInt(AdjQtySupplierArray[index].min_order_qty)) {
                                QtyToBeChanged = MinQty;
                                AdjQtySupplierArray[index].QuantityOrdered = QtyToBeChanged;
                                SuppllierGridArray = AdjQtySupplierArray;
                                this.setState({ SupllierGridArray: AdjQtySupplierArray });
                                IsValidqty = true;
                            }
                        }
                    }
                }
                else if (e.target.value == "-") {

                    let IsValidqty = false
                    let MinQty = AdjQtySupplierArray[index].min_order_qty;
                    while (!IsValidqty) {
                        if (parseInt(MinQty) < parseInt(AdjQtySupplierArray[index].QuantityOrdered)) {
                            let diff = parseInt(AdjQtySupplierArray[index].QuantityOrdered) - parseInt(MinQty);
                            if (diff <= AdjQtySupplierArray[index].min_order_qty) {
                                QtyToBeChanged = MinQty;
                                AdjQtySupplierArray[index].QuantityOrdered = QtyToBeChanged;
                                SuppllierGridArray = AdjQtySupplierArray
                                this.setState({ SupllierGridArray: AdjQtySupplierArray });
                                IsValidqty = true;
                            }
                            else {
                                MinQty = parseInt(MinQty) + parseInt(AdjQtySupplierArray[index].min_order_qty);
                            }

                        }
                    }
                }
            }
        }
        else {
            if (e.target.value == "+") {
                QtyToBeChanged = parseInt(AdjQtySupplierArray[index].QuantityOrdered) + parseInt(AdjQtySupplierArray[index].min_order_qty);
                AdjQtySupplierArray[index].QuantityOrdered = QtyToBeChanged;
                SuppllierGridArray = AdjQtySupplierArray
                this.setState({ SupllierGridArray: AdjQtySupplierArray });
            }
            else if (e.target.value == "-") {
                QtyToBeChanged = parseInt(AdjQtySupplierArray[index].QuantityOrdered) - parseInt(AdjQtySupplierArray[index].min_order_qty);

                if (QtyToBeChanged == 0 || QtyToBeChanged == "0") {
                    e.preventDefault();
                }
                else {
                    AdjQtySupplierArray[index].QuantityOrdered = QtyToBeChanged;
                    SuppllierGridArray = AdjQtySupplierArray
                    this.setState({ SupllierGridArray: AdjQtySupplierArray });
                }
            }
        }

    };






    CoreChargeResponseClick = () => {
        //debugger
        const {t} = this.props
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Status = JSON.parse(SupplierSuggestionStore.SupplierStatus);
        let itemstatus = Status._FlagDt;
        let iteminsertstatus = Status.SuccessFLag;
        let FromNonCat = "";
        if (this.props.location.state.FromNonCat === "noncat") {  //[10/3/2023] - 4252 - PC_WW_826_06 - Vishwa S
            FromNonCat = "noncat"
        }
        if (itemstatus.length > 0) {
            if (itemstatus[0].is_Success == "True" || itemstatus[0].is_Success == "true") {
                let itemidnotinserted = ""
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                    });
                }




                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + itemidnotinserted +t(" is not added to cart due to technical issue. Contact SDI customer care.")
                    });
                    return;
                }
                if (iteminsertstatus[0].CORE_CHARGE != "" && iteminsertstatus[0].CORE_CHARGE != " " && iteminsertstatus[0].CORE_CHARGE != null) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("Item successfully added to cart and added item applies core charges")
                    });
                    if (FromPageName == "SearchResult") {
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        let searchkeyvalue = SearchKey.replace(/&/g, "%26") //WW-875_PC_01
                        searchkeyvalue = searchkeyvalue.replace(/#/g, "%23")
                        this.props.history.push({
                            pathname: `\searchresults`,
                            search: `?key=${searchkeyvalue}`,
                            state: { ImageSearch: IsImageSearch, ImageFiles: ImageFiles, image: image }
                        });
                    }
                    else {
                        let ItemDet = this.state.FiltItemValue;
                        let CurrentItemDet = CookieService.getLocalStorageValues("ItemAddedToCart");
                        if (CurrentItemDet != undefined || CurrentItemDet != null || CurrentItemDet != {}) {
                            ItemDet = CurrentItemDet
                        }
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        CookieService.updateLocalStorageValues("Search_ItemFav", ItemDet.IsSupplierFav);
                        this.props.history.push({
                            pathname: `\itemdetailnew`,
                            search: `?ItemId=${ItemDet.clientPartNumber}&ManufacturePartNumber=${ItemDet.manfPartNumber}&ManufactureName=${ItemDet.manufacturer}&SupplierID=${ItemDet.vendor_id}&QTY=${ItemDet.min_order_qty}`,
                            state: { IsAltPart: IsAltPart, WO: JSON.parse(localStorage.getItem("WONum")), ItemData: ItemDet, Suggesstions: false, Page: "TsSupplierSugg", Orgin: FromNonCat } //[10/3/2023] - 4252 - PC_WW_826_07 - Vishwa S
                        });
                    }

                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("Item successfully added to cart")
                    });
                    $('#ReasonPopup').modal('hide');
                    if (FromPageName == "SearchResult") {
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        let searchkeyvalue = SearchKey.replace(/&/g, "%26") //WW-875_PC_01
                        searchkeyvalue = searchkeyvalue.replace(/#/g, "%23")
                        this.props.history.push({
                            pathname: `\searchresults`,
                            search: `?key=${searchkeyvalue}`,
                            state: { ImageSearch: IsImageSearch, ImageFiles: ImageFiles, image: image }

                            //state: { ImageSearch: false, ImageFiles: "", image: "" }
                        });
                    }
                    else {
                        let ItemDet = this.state.FiltItemValue;
                        let CurrentItemDet = CookieService.getLocalStorageValues("ItemAddedToCart");
                        if (CurrentItemDet != undefined || CurrentItemDet != null || CurrentItemDet != {}) {
                            ItemDet = CurrentItemDet
                        }
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        CookieService.updateLocalStorageValues("Search_ItemFav", ItemDet.IsSupplierFav);
                        this.props.history.push({
                            pathname: `\itemdetailnew`,
                            search: `?ItemId=${ItemDet.clientPartNumber}&ManufacturePartNumber=${ItemDet.manfPartNumber}&ManufactureName=${ItemDet.manufacturer}&SupplierID=${ItemDet.vendor_id}&QTY=${ItemDet.min_order_qty}`,
                            state: { IsAltPart: IsAltPart, WO: JSON.parse(localStorage.getItem("WONum")), ItemData: ItemDet, Suggesstions: false, Page: "TsSupplierSugg", Orgin: FromNonCat } //[10/3/2023] - 4252 - PC_WW_826_09 - Vishwa S
                        });
                    }
                }
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t(" Item Cannot be added to cart due to technical issue. Contact SDI customer care.")
                });
                return;
            }
        }
    };
    AddToCartOrFavClick = (CartOrFav, value, index, popup, ReasonType, Comments) => {
        this.setState({ ReasonType: "", Comments: "" })
        //[12/15/22], PC_WW-552_FE_4, Dhevanesam R
        CookieService.updateLocalStorageValues("AddIndex", index);
        CookieService.updateLocalStorageValues("AddValue", value);
        console.error("DivisTestAddValue", CookieService.getLocalStorageValues("AddValue"))
        console.error("DivisTestOnlyValue", value)
        this.setState({ AddIndex: index, AddValue: value });

    
        let formName = "";
        if (value != undefined && value.AttributeName != undefined && value.AttributeName != null && value.AttributeName != "" && value.AttributeName.includes('FORM')) {
            formName = value.form.trim()
        }

        if (CartOrFav == "Add To Cart") {
            if (value.AttributeName != undefined && value.AttributeName.includes('FORM')) {
                if (formName != null && formName != "" && formName != undefined) {
                    //if (formName.toLowerCase().includes("battery") || formName.toLowerCase().includes("charger")) {
                    //    FormDataProps = []
                    //    FormOptionsDataProps = []
                    //    this.AddToCart(value, index, false);//WW-694_PC_04(to make sure not from core charge popup) -Aparna
                    //}
                    // else {
                    let dynamicFormBO = {
                        formName: formName
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    SupplierSuggestionAction.dynamicFormData(dynamicFormBO);
                    //  }
                }
                else {
                    FormDataProps = []
                    FormOptionsDataProps = []
                    this.AddToCart(value, index, false, this.state.ReasonType, this.state.Comments);//WW-694_PC_04(to make sure not from core charge popup) -Aparna
                }
            }
            else {
                FormDataProps = []
                FormOptionsDataProps = []
                this.AddToCart(value, index, false, this.state.ReasonType, this.state.Comments);//WW-694_PC_04(to make sure not from core charge popup) -Aparna
            }
        }
        else {
            this.AddToFav(value, index, popup);
        }
    };
    //[12/15/22], PC_WW-552_FE_9, Dhevanesam R
    dynamicFormReponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        
        let DynamicFormResData = JSON.parse(SupplierSuggestionStore.dynamicFormResponse);
        let FormDataDtArr = []
        let OptionsDataDtArr = []
        if (DynamicFormResData.ErrorMessageDT != null && DynamicFormResData.ErrorMessageDT != undefined) {
        
            if (DynamicFormResData.ErrorMessageDT.length > 0) {
              
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: DynamicFormResData.ErrorMessageDT[0].ErrorMessage
                });
                return;
            }
        }
        else {
            if (DynamicFormResData.FormDataDt != null && DynamicFormResData.FormDataDt != undefined) {
                if (DynamicFormResData.FormDataDt.length > 0) {
                    FormDataDtArr = DynamicFormResData.FormDataDt
                }
            }
            if (DynamicFormResData.OptionsDataDt != null && DynamicFormResData.OptionsDataDt != undefined) {
                if (DynamicFormResData.OptionsDataDt.length > 0) {
                    OptionsDataDtArr = DynamicFormResData.OptionsDataDt
                }
            }
        }
        FormDataProps = FormDataDtArr
        FormOptionsDataProps = OptionsDataDtArr
        this.setState({ FormData: FormDataDtArr, FormOptionsData: OptionsDataDtArr });
        let AddValue = CookieService.getLocalStorageValues("AddValue");
        let AddIndex = CookieService.getLocalStorageValues("AddIndex");
        this.AddToCart(this.state.ItemDetail, this.state.AddIndex, false);//WW-694_PC_04(to make sure not from core charge popup) -Aparna
    }
    AddToFav = (value, index, popup) => {
     
        if (value == "") {
            value = this.state.FiltItemValue;
            index = this.state.FiltItemIndex;
        }
        let FavSDICatg = value.UNSPSCCategory == null || value.UNSPSCCategory == "" || value.UNSPSCCategory == " " ? "UnClassified" : value.UNSPSCCategory;
        let Itemtypevalue = "CAT"
        this.setState({
            FavItemIdPopUp: value.clientPartNumber, FavSDICatgPopUp: FavSDICatg,
            FavItemDescripPopUp: value.longdescriptionone, FavMFGPopUp: value.manufacturer,
            FavMFGPartNUMPopUp: value.manfPartNumber, txtUOMHidePopUp: value.UOM,
            txtMfgItemidHidePopUp: value.manfPartNumber,
            txtItemidHidePopUp: value.clientPartNumber,
            txtMFGHidePopUp: value.vendor_id,
            ItemType: Itemtypevalue,
            FavitemImage: value.ThumbnailImagefile,
            FavSAP: value.customer_part_number_woprefix,
            FavYourCatg: popup == "Yes" ? this.state.FavYourCatg : "",
            FiltItemValue: value,
            FiltItemIndex: index,
            FavSAP: value.customer_part_number_woprefix
        })
        document.getElementById("txtUOMHide").hidden = true
        document.getElementById("txtMfgItemidHide").hidden = true
        document.getElementById("txtItemidHide").hidden = true
        document.getElementById("txtMFGHide").hidden = true
        document.getElementById("ItemType").hidden = true
        $('#add-fav-popup').modal('show');
        $('#FavYourCatg').val('');
        $('#FavYourDescrip').val('');
        //WW-368_SuggestionCat_for_searchresult_PC_05 -Aparna 
        let autoCompleteDataRes = []
        let locsugg = []
        let suggestionsStr = CookieService.getLocalStorageValues("Fav_Item_Cat")
        if (suggestionsStr != null && suggestionsStr != "" && suggestionsStr != undefined) {
            suggestionsStr.forEach((sugg, index) => {
                autoCompleteDataRes.push({ label: sugg.ISA_FAVS_CATEGORY, value: sugg.ISA_FAVS_CATEGORY });
            });
        }
        this.setState({ autocompleteData: autoCompleteDataRes, CategoryErr: false });
        this.setState({ attachmentPathArr: [], SelectedValueImg: value.Image });

    }
    //WW-694_PC_02 -Aparna
    AddToCart = (value, index, fromCorePopup, ReasonType, Comments) => {
        // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
        //WW-694_PC_02 -Aparna
        const { t } = this.props
        if (value != undefined && value != null) {
            this.setState({ AddIndex: index, AddValue: value })
        } else {
            value = this.state.AddValue
            index = this.state.AddIndex
        }

        let AdjQtySupplierArray = this.state.SupllierGridArray;
        let form = "";
        let actualQty = "";
        if (AdjQtySupplierArray[0].actual_qty != null && AdjQtySupplierArray[0].actual_qty != undefined) {
            let QuantityOnhandL = AdjQtySupplierArray[0].actual_qty;
            actualQty = QuantityOnhandL.split('^')[0];
        }



        if (parseInt(AdjQtySupplierArray[index].QuantityOrdered) < parseInt(AdjQtySupplierArray[index].min_order_qty)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Entered Is Below The Minimum Order Quantity')
            });
            return;
        }
        else if ((parseInt(AdjQtySupplierArray[index].QuantityOrdered) % parseInt(AdjQtySupplierArray[index].min_order_qty)) != 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Entered Quantity Does Not Match the Minimum Order Quantity Sequence')
            });
            return;
        }
        else if (parseInt(AdjQtySupplierArray[index].QuantityOrdered) == "0" || parseInt(AdjQtySupplierArray[index].QuantityOrdered) == 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Quantity Cannot Be Zero')
            });
            return;
        }
        // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
        else if ((parseInt(AdjQtySupplierArray[index].QuantityOrdered) > actualQty && AdjQtySupplierArray[index].vendor_id == "W999999999")) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Entered Quantity is Greater than the Available Quantity ')
            });
            return;
        }
        else if (value.AttributeValue != undefined && (value.AttributeValue.indexOf("BATTERY") > -1 || value.AttributeValue.indexOf("CHARGER") > -1)) {
            //let EnersysFormVaue = value.AttributeValue;
            let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));

            let EnersysItem = []
            EnersysItem = CartStorage.filter((item, index) => item.Itemid == value.clientPartNumber);

            if (EnersysItem.length > 0 && EnersysItem != undefined && EnersysItem != null && EnersysItem != []) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "This " + value.form.trim() + t(" Item is already added in the cart ")
                });
                return;
            }
        }

        //WW-694_PC_02(if the method is called from core charge popup then it should not display) -Aparna
        if (value != undefined && value.hasCoreCharge && fromCorePopup == false) {
            $('#CoreChargePopUp').modal('show');
            return;
        }
        //[12/15/22], PC_WW-552_FE_10, Dhevanesam R
        else if (FormDataProps.length > 0 && FormDataProps != "" && FormDataProps != undefined && FormDataProps != []) {
            if (value != undefined && value.AttributeName.includes('FORM')) {
                this.CheckFormExistsInCart(value);
                let AddToCartBO = this.FormCartBO(index);
                //[1/11/23, WW-552, Dhevanesam R]

                // this.setState({ EnersysFormVaue: EnersysFormVaue, EnersysForm: true, EnersysEmp: "Are you working on an enersys(nextsys) " + EnersysFormVaue.toLowerCase() });
                // CookieService.updateLocalStorageValues("EnersysFormVaue", EnersysFormVaue)
                //CookieService.updateLocalStorageValues("EnersysForm", true)
                //if (CookieService.getLocalStorageValues("EnersysForm") == true) {
                //    if (EnersysItems != undefined) {
                //        if ((EnersysItems.indexOf(value.clientPartNumber) == -1)) {
                //            $('#EnersysEmployee').modal('show');
                //            return;

                //        }

                //    }
                //    else {
                //        $('#EnersysEmployee').modal('show');
                //        return;
                //    }
                //}
                // }
                //else {
                //[1/20/23, PC_WW-552_FE_41, Dhevanesam R]
                if (FormItems != undefined && FormItems != null && FormFilePath != undefined && FormFilePath != null && value.form != undefined && value.form != null) {

                    if (value.form.trim() == "KENSTAN-KEY" && FormFilePath.includes("KENSTAN-KEY")) {
                   
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: t("KENSTAN-KEY is already added to cart, only one key allow for one cart. Please go to cart to increase quantity")
                        });
                        FormItems = "";
                        FormFilePath = "";
                        return;
                    }
                    else {
                        let CartStorage = JSON.parse(localStorage.getItem("CartStorage")) || [];
                        let itemInCart = CartStorage.filter(item => item.Itemid === value.clientPartNumber && item.SupplierPartNumber === value.supplier_part_number && item.SupplierID == value.vendor_id && item.Manufacturerpartnumber === value.manufacturer_part_number && item.Manufacturer === value.manufacturer_name);
                        if (itemInCart.length == 0) {
                            FormItems = "";
                            FormFilePath = "";
                            this.props.history.push({
                                pathname: "/forms",
                                state: { item: AddToCartBO, qty: value.QuantityOrdered, WO: WorkOrder, pagename: FromPageName, searchKey: SearchKey, form: form, FormData: FormDataProps, FormOptionsData: FormOptionsDataProps, FormName: value.form.trim() }
                            });
                        }
                        else if (itemInCart.length > 0 && itemInCart[0].FilePath && itemInCart[0].FilePath.length == 10) {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: t('This item is already in the cart and has reached the maximum number of 10 forms')
                            });
                            return true;
                        }
                        else {
                            let AddToCartBO = this.FormCartBO(index);
                            CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                            this.setState({ FiltItemValue: value });
                            SupplierSuggestionAction.AddCart(AddToCartBO);
                            $(`#${SDIConstants.SDILoader}`).removeClass('hide')
                        }
                    }

                } else {
                    if (FormDataProps != "" || FormDataProps != undefined || FormDataProps != []) {

                        this.props.history.push({
                            pathname: "/forms",
                            state: { item: AddToCartBO, qty: value.QuantityOrdered, WO: WorkOrder, pagename: FromPageName, searchKey: SearchKey, form: form, FormData: FormDataProps, FormOptionsData: FormOptionsDataProps, FormName: value.form.trim() }
                        });
                    }
                    else {
                        let AddToCartBO = this.FormCartBO(index);
                        CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                        this.setState({ FiltItemValue: value });
                        SupplierSuggestionAction.AddCart(AddToCartBO);
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide')
                    }
                }



                // }

            }
            else {

                let AddToCartBO = this.FormCartBO(index);
                CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                this.setState({ FiltItemValue: value });
                SupplierSuggestionAction.AddCart(AddToCartBO);
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            }
        }
        else {

            let AddToCartBO = this.FormCartBO(index);
            CookieService.updateLocalStorageValues("ItemAddedToCart", value);
            this.setState({ FiltItemValue: value });
            SupplierSuggestionAction.AddCart(AddToCartBO);
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }

    };
    //[1/11/23, WW-552, Dhevanesam R]
    //[1/20/23, PC_WW-552_FE_40, Dhevanesam R]
    CheckFormExistsInCart = (value) => {
        let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
        CartStorage.forEach((val) => {
            if (val.FilePath != undefined && val.FilePath != null && val.FilePath != "" && val.FilePath != " ") {
                if (val.FilePath[0].toLowerCase().includes('enersys')) {
                    EnersysItems = EnersysItems.concat(val.Itemid);
                }
                else if (val.FilePath != null && val.FilePath[0].toUpperCase().includes(value.form.trim())) {
                    FormItems = FormItems.concat(val.Itemid);
                    FormFilePath = FormFilePath.concat(val.FilePath[0]);
                }

            }
        });
    }
    CoreChargePopUpclose = (e) => {
        $('#CoreChargePopUp').modal('hide');
    }
    CoreChargeProceedClick = (e) => {
        $('#CoreChargePopUp').modal('hide');
        let Index = this.state.AddIndex;
        let GridArray = this.state.SupllierGridArray;
        CookieService.updateLocalStorageValues("ItemAddedToCart", GridArray[Index]);
        this.setState({ FiltItemValue: GridArray[Index] });
        let AddToCartBO = this.FormCartBO(Index);
        SupplierSuggestionAction.AddCart(AddToCartBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    FormCartBO = (Index) => {
        let GridArray = this.state.SupllierGridArray;
        let OrderNonCatalogItemL = [];
        let suppllier_part_num = GridArray[Index].supplier_part_number;
        if (suppllier_part_num == "" || suppllier_part_num == undefined || suppllier_part_num == null) {
            suppllier_part_num = GridArray[Index].clientPartNumber;
        };
        let ItemDetails = {
            ItemId: GridArray[Index].clientPartNumber,
            txtSupplier: GridArray[Index].supplierName,
            txtSupplierID: GridArray[Index].vendor_id,
            txtSuppPartNum: suppllier_part_num,
            txtEstPrice: GridArray[Index].ItemPrice,
            txtDesc: GridArray[Index].Description + " " + "-InvItemIcon-" + GridArray[Index].hasBenItemVal,
            txtMfgPartNum: GridArray[Index].manfPartNumber,
            txtMfgName: GridArray[Index].manufacturer,
            txtQty: GridArray[Index].QuantityOrdered,
            image_url: GridArray[Index].ThumbnailImagefile,
            DropUOM: GridArray[Index].UOM,
            rblcatalogVisible: false,
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            filePath: null,
            EMPCC: "",
            DUeDate: GridArray[Index].DeliverDate,
            Type: "",
            MachineNo: "",
            Notes: "",
            Priority: "",
            SAP_ARTCILE_NUMBER: GridArray[Index].customer_part_number_woprefix,
            ItemCat: GridArray[Index].UNSPSC,
            MIN_ORD_QTY: GridArray[Index].min_order_qty,
            CORE_CHARGE: GridArray[Index].core_charges,
            REASON_TYPE: this.state.ReasonType.value,
            COMMENTS: this.state.Comments
        };
        OrderNonCatalogItemL.push(ItemDetails);
        let AddToCartBO = {
            ItemDetails: [],
            NonItemDetails: OrderNonCatalogItemL,
            Session_BUSUNIT: this.state.Login_UserBU,
            Session_USERID: this.state.Login_UserId,
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ImageLocPath: "",
            Session_PUNCHIN: "False",
            MobileAPICall: false,
            Session_ID: CookieService.getLocalStorageValues("Session_ID"),
            SOURCE: "WEB",
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
        }
        return AddToCartBO;
    }
    EnersysyEmp = (EnersysEmp, value) => {
        if (EnersysEmp == "No") {
            $('#NotanEnersysEmp').modal('show');
        }
        else if (EnersysEmp == "Add to Cart") {
            let isEnersys = false
            $('#EnersysEmployee').modal('hide');

            let Index = this.state.AddIndex;
            let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
            CartStorage.forEach((val) => {
                if (val.Itemid == value.clientPartNumber) {
                    isEnersys = true

                }
            })

            if (isEnersys) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "This Enersys Item is already added in the cart"
                });
                return;
            }
            //let GridArray = this.state.SupllierGridArray;
            //let suppllier_part_num = GridArray[Index].supplier_part_number;
            //if (suppllier_part_num == "" || suppllier_part_num == undefined || suppllier_part_num == null) {
            //    suppllier_part_num = GridArray[Index].clientPartNumber;
            //}
            //if (value.clientPartNumber  == suppllier_part_num) {
            //    swal({
            //        allowOutsideClick: false,
            //        closeOnClickOutside: false,
            //        text: "This Enersys Item is already added in the cart. Please go to cart to increase quantity !"
            //    });
            //    return;
            //}
            else {

                let AddToCartBO = this.FormCartBO(Index);
                //  CookieService.updateLocalStorageValues("ItemAddedToCart", value);
                //this.setState({ FiltItemValue: value });
                SupplierSuggestionAction.AddCart(AddToCartBO);
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');



            }
        };
        //}else if (EnersysEmp == "Yes") {
        //    $('#EnersysEmployee').modal('hide');
        //    let index = this.state.AddIndex;
        //    let AddToCartBO = this.FormCartBO(index);
        //    let GridArray = this.state.SupllierGridArray;
        //    this.props.history.push({
        //        pathname: "/EnersysForm",
        //        state: { item: AddToCartBO, qty: GridArray[index].QuantityOrdered, product: CookieService.getLocalStorageValues("EnersysFormVaue"), WO: WorkOrder, pagename: FromPageName, searchKey: SearchKey, form: CookieService.getLocalStorageValues("EnersysForm") }
        //    });

        //}
    }
    NotAnEnersysyEmp = () => {
        $('#NotanEnersysEmp').modal('hide');
    }
    GetSupplierList = (MFGPartNo) => {
        let ShipmentMethod = localStorage.getItem("pickupcheck") != null ? JSON.parse(localStorage.getItem("pickupcheck")) : false;
        if (ShipmentMethod == false && IsPickup == true) {
            ShipmentMethod = true
        }
        else if (ShipmentMethod == true && IsPickup == false) {
            ShipmentMethod = false

        }
        //console.log("LOCATION", CookieService.getLocalStorageValues("LOCATION") != null ? CookieService.getLocalStorageValues("LOCATION").substring(0, 2) : "");
        let SearchBO = {
            Session_USERID: this.state.Login_UserId,
            Session_BUSUNIT: this.state.Login_UserBU,
            AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            CurrentPage_URL: "/suppliersuggestionpage",
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_SearchQuery: MFGPartNo,
            Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
            SearchValue: MFGPartNo,
            Query_SITE: "",
            Query_USERID: this.state.Login_UserId,
            Query_Key: MFGPartNo,
            Query_Opt: "",
            chbCat: true,
            Quantity: Qty,
            chbNonCat: true,
            Catagorylist: [],
            Make: "",
            Model: "",
            AssetId: "",
            SupplierIdList: [],
            ManufacturerList: [],
            WorkOrder: localStorage.getItem("WONum") != null && localStorage.getItem("WONum") != undefined ? JSON.parse(localStorage.getItem("WONum")) : "",
            ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
            Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
            FavYourCatg: "",
            Session_ID: CookieService.getLocalStorageValues("Session_ID"),
            SOURCE: "WEB",
            IsSupplierSearch: true,
            mfg: MFGName,
            mfgpartno: MFGPartNo,
            IsPickupSupplier: ShipmentMethod,
            suppliersuggestion: true,
            category: CookieService.getLocalStorageValues("Trade") != null && CookieService.getLocalStorageValues("Trade") != undefined && CookieService.getLocalStorageValues("Trade") != "" ? CookieService.getLocalStorageValues("Trade").toUpperCase() : " ",//CookieService.getLocalStorageValues("WO_Category"),
            priority_cd: CookieService.getLocalStorageValues("WO_Priority") != undefined && CookieService.getLocalStorageValues("WO_Priority") != null && CookieService.getLocalStorageValues("WO_Priority") != "" ? "Y" : "N",
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            EquipmentDelete: cartDelete,
            Interactive: false
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        SupplierSuggestionAction.GetpageLoad(SearchBO);
    };

    CloseFavoritePopup = () => {
        this.setState({ FavItem: false });
        $('#add-fav-popup').modal('hide');
    }
    handleAttachment = (event) => {
        let files = event.target.files;
        console.log("event", files);
        if (this.state.attachmentPathArr != undefined) {

            if (this.state.attachmentPathArr.length < 1) {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                NonCatalogAction.addAttachment(files);
            } else {

                let lblerror = "You can choose only one Image"
                document.getElementById("lblerror").innerText = lblerror;
            }

        } else {
            document.getElementById("lblerror").innerText = "";
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            NonCatalogAction.addAttachment(files);
        }
    };
    // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
    SupplierListReponse = () => {
        const {t}=this.props
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        window.scrollTo(0, 0);
       
        let PageLaod_Data = JSON.parse(SupplierSuggestionStore.SearchresultList);
        let Favmenu = PageLaod_Data.FavMenu;
        let Favsub = PageLaod_Data.FavSubMenu;
        let SupplierArray = PageLaod_Data.SearchItemTable;
        let PrefSupplierReason = PageLaod_Data.SupplierReason;
        let SupplierLocArray = [];
        let updateSession = PageLaod_Data.Update_Session;
        //Get manufacturer name from props-Priyanka-INC0013356
        let MfgName = this.props.location.state.ManufactureName;
        let MfgPart = this.props.location.state.ManufacturePartNumber;
        let AlternateParts = this.props.location.state.AlternatePart;
        let ItemDetail = this.props.location.state.Itemdetail;
        let VendorId = this.props.location.state.VendorId;
        let ItemId = this.props.location.state.ItemId;
        let FromNonCat = this.props.location.state.FromNonCat;
        //Vendor_ID = SupplierArray.vendor_id;
        //[10/3/2023] - 4252 - PC_WW_826_08 - Vishwa S
        //if (SupplierArray != undefined) {
        //    if (SupplierArray.length > 0) {
        //        SupplierArray = SupplierArray.filter((item, index) => item.mfg_part_number.toLowerCase() == MFGPartNo.toLowerCase() && item.manufacturer_name.toLowerCase() == MfgName.toLowerCase());
        //    }
        //}
        console.log("SupplierLocArray", SupplierArray)
        ReasonArray = PrefSupplierReason

        if (SupplierArray != undefined && SupplierArray.length > 0) {
            SupplierArray.forEach((value, index) => {
                LongDesc = value.longdescriptionone;
                value.IsQtyChanged = false;
                value.EditedQuantity = false;

                //if (value.mfg_part_number == MFGPartNo && value.manufacturer_name == MFGName && value.supplierName == SupplierName) {
                value.QuantityOrdered = Qty;
                //}
                //else {
                //    value.QuantityOrdered = value.min_order_qty;
                //}
                if ((parseInt(Qty) % parseInt(value.min_order_qty)) != 0) {
                    value.minOrderQtyCheck = true;
                }
                else {
                    value.minOrderQtyCheck = false;
                }
                value.hasCoreCharge = false;
                value.IsSupplierFav = false;
                value.DeliverDate = "";
                value.DeliverDate = this.calcWorkingDaysNew(value.ships_within);
                let imagePath = "";
                if (value.ThumbnailImagefile) {
                    value.Image = value.ThumbnailImagefile.replace('\\', '/');
                    if (value.Image.toLowerCase().indexOf("http") >= 0) {
                        imagePath = value.ThumbnailImagefile;
                    } else {
                        imagePath = value.ThumbnailImagefile.lastIndexOf(`/`) >= 0 ? value.ThumbnailImagefile.substring(value.ThumbnailImagefile.lastIndexOf("/") + 1, value.ThumbnailImagefile.length) : "noimage_new.png";
                        if (imagePath) {
                            imagePath = `/Images/${imagePath}`;
                        }
                    }
                } else {
                    imagePath = `/Images/noimage_new.png`;
                }

                if (value.core_charges != "\\N" && value.core_charges != "" && value.core_charges != undefined && value.core_charges.length > 0) {
                    value.hasCoreCharge = true;
                }
                //WW-591_PC_04 -Aparna
                //if (value.supplierName.includes("Preferred")) {
                if (value.actual_qty != undefined && value.actual_qty != null && value.actual_qty != "") {
                    value.hasBenItemVal = value.actual_qty.slice(-1);
                }
                SupplierLocArray.push(value);
                // }

                value.IsSupplierFav = Favsub.filter((item, index) => item.CUSTOMERITEMID == value.clientPartNumber && (item.MANUFACTURER.includes("&apos;") ? item.MANUFACTURER.replace("&apos;", "'") : item.MANUFACTURER.toUpperCase() == MfgName.toUpperCase() && item.SUPPLIER_ID == value.vendor_id)).length > 0 ? true : false;
            });
            console.log("SupplierLocArray", SupplierLocArray)
            console.log("SupplierLocArray", SupplierArray)
            //SupplierArray.forEach((value, index) => {
            //    if (!value.supplierName.includes("Preferred")) {
            //        SupplierLocArray.push(value);
            //    }
            //});
            //SupplierArray.forEach((value, index) => {
            //    if (value.vendor_id != "W999999999" && !value.supplierName.includes("Preferred")) {
            //        SupplierLocArray.push(value);
            //    }
            //});
        }
        else {
            let qtt = ""
            let origin = this.props.location.state.origin
            // window.history.go(-1)

            if (updateSession[0].IsInvQtyZero == true) {

                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("Item quantity is not available")
                })
            }
            else if (updateSession[0].IsEnteredGreaterQTY == true) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("No suppliers available for the entered quantity")
                })
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("No suppliers found for the item")
                })
            }


            if (origin == "itemDetail") {

                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                this.props.history.push({
                    pathname: `\itemdetailnew`,
                    search: `?ItemId=${ItemId}&ManufacturePartNumber=${MfgPart}&ManufactureName=${MfgName}&SupplierID=${VendorId}&QTY=${ItemDetail.min_order_qty}`,
                    state: { IsAltPart: IsAltPart, WO: JSON.parse(localStorage.getItem("WONum")), ItemData: ItemDetail, Suggesstions: false, Page: "TsSupplierSugg", Orgin: FromNonCat } //[10/3/2023] - 4252 - PC_WW_826_09 - Vishwa S
                });



            }
            else {

                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                let searchqueryParamsValue = SearchKey.replace(/&/g, "%26") //WW-875_PC_01
                searchqueryParamsValue = searchqueryParamsValue.replace(/#/g, "%23")
                this.props.history.push({
                    pathname: `\searchresults`,
                    search: `?key=${searchqueryParamsValue}`,
                    state: { ImageSearch: IsImageSearch, ImageFiles: ImageFiles, image: image }

                    //state: { ImageSearch: false, ImageFiles: "", image: "" }
                });
            }



        }
        // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
        this.setState({ SupllierGridArray: SupplierLocArray, ReasonArray: PrefSupplierReason });

        SuppllierGridArray = SupplierLocArray

        this.bindReason(PageLaod_Data)
        //this.bindReason(ReasonArray)
    };

    //WW-1216 Precart ratings and reviews - Yuvarani K
    bindReason = (PageLaod_Data) => {
        let Reasons = PageLaod_Data.SupplierReason;
        let ReasonsDD = [];
        if (Reasons != undefined && Reasons != null && Reasons != "") {
            Reasons.map((item, index) => {
                let obj = {
                    value: item.REASON_TYPE,
                    label: item.REASON_TYPE
                }
                ReasonsDD.push(obj);
            })
            //ReasonList = ReasonsDD

        }
        else {
            let obj = {
                value: "Other",
                label: "Other"
            }
            ReasonsDD.push(obj);
            // ReasonList = ReasonsDD
        }

        this.setState({ ReasonList: ReasonsDD })

    }
    DirectSuggestion = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        window.scrollTo(0, 0);
     
        let Favsub = CookieService.getLocalStorageValues("SuggFavItem");
        let SupplierArray = CookieService.getLocalStorageValues("SuggestedSupplierList");
        let SupplierLocArray = [];
        //Get manufacturer name from props-Priyanka-INC0013356
        let MfgName = this.props.location.state.ManufactureName;
        let ChoMfgName = CookieService.getLocalStorageValues("ChosenMFGName");
        SupplierArray = SupplierArray.filter((item, index) => item.mfg_part_number == MFGPartNo && item.manufacturer_name == ChoMfgName);
        if (SupplierArray != undefined && SupplierArray.length > 0) {
            SupplierArray.forEach((value, index) => {
                LongDesc = value.longdescriptionone;
                value.IsQtyChanged = false;
                value.EditedQuantity = false;
                if (value.mfg_part_number == MFGPartNo && value.manufacturer_name == MFGName && value.supplierName == SupplierName) {
                    value.QuantityOrdered = Qty;
                }
                else {
                    value.QuantityOrdered = value.min_order_qty;
                }
                value.hasCoreCharge = false;
                value.IsSupplierFav = false;
                value.DeliverDate = "";
                value.DeliverDate = this.calcWorkingDaysNew(value.ships_within);
                let imagePath = "";
                if (value.ThumbnailImagefile) {
                    value.Image = value.ThumbnailImagefile.replace('\\', '/');
                    if (value.Image.toLowerCase().indexOf("http") >= 0) {
                        imagePath = value.ThumbnailImagefile;
                    } else {
                        imagePath = value.ThumbnailImagefile.lastIndexOf(`/`) >= 0 ? value.ThumbnailImagefile.substring(value.ThumbnailImagefile.lastIndexOf("/") + 1, value.ThumbnailImagefile.length) : "noimage_new.png";
                        if (imagePath) {
                            imagePath = `/Images/${imagePath}`;
                        }
                    }
                } else {
                    imagePath = `/Images/noimage_new.png`;
                }

                if (value.core_charges != "\\N" && value.core_charges != "" && value.core_charges != undefined && value.core_charges.length > 0) {
                    value.hasCoreCharge = true;
                }
                if (value.vendor_id == "W999999999") {
                    SupplierLocArray.push(value);
                }
                value.IsSupplierFav = Favsub.filter((item, index) => item.CUSTOMERITEMID == value.clientPartNumber && (item.MANUFACTURER.includes("&apos;") ? item.MANUFACTURER.replace("&apos;", "'") : item.MANUFACTURER.toUpperCase() == MfgName.toUpperCase() && item.SUPPLIER_ID == value.vendor_id)).length > 0 ? true : false;
            });
            SupplierArray.forEach((value, index) => {
                if (value.vendor_id != "W999999999") {
                    SupplierLocArray.push(value);
                }
            });
        }

        this.setState({ SupllierGridArray: SupplierLocArray });
        SuppllierGridArray = SupplierLocArray
    };
    onAccordianClick = (event, index) => {
    
        let classname = document.getElementById(`collapseOne${index}`).className;
        let id = 'collapseOne' + index;
        let acc = 'accordianicon' + index;
        let selector = '#' + id;
        let accordianid = '#' + acc;
        let acclass = document.getElementById(acc).className
        if (acclass == "accordion-heading") {
            $(accordianid).removeClass('accordion-heading');
            $(accordianid).addClass('accordian-close');
        } else {
            $(accordianid).removeClass('accordian-close');
            $(accordianid).addClass('accordion-heading');
        }
        if (classname.includes("d-none")) {
            $(selector).removeClass('d-none');
        }
        else {
            $(selector).addClass('d-none');
        }


    };
    calcWorkingDaysNew = (shipwithin) => {
      
        let count = 0;
        //[2/10/23, PC_WW-621_APP_01, Dhevanesam R]
        let tomorrow = new Date()
        tomorrow.setDate(tomorrow.getDate() + 1); // to exclude today's date
        console.log("tomorrow's date", tomorrow)
        console.log("no.of days", shipwithin)
        while (count < shipwithin) {
            if (tomorrow.getDay() != 0 && tomorrow.getDay() != 6) // Skip weekends
            {
                count++;
            }
            //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
            tomorrow.setDate(tomorrow.getDate() + 1);
        }
        //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
        tomorrow.setDate(tomorrow.getDate() - 1);
        let td = this.handledate(tomorrow);
        let Sampletest = "" + td
        return Sampletest;
    }
    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }
    }
    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.value}`;
    }
    renderItem(item, isHighlighted) {
        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );

    }
    onChange = (e) => {
        let val = e.target.value.toUpperCase()
        let len = e.target.value
        if (e.target.value == "") {
            //let result = this.state.autocompleteData.filter(name => name.label.toUpperCase().includes(val))
            this.setState({
                FavYourCatg: e.target.value, autocompleteDataRstl: []
            });
        }
        else if (len.length <= 40) {
            let result = this.state.autocompleteData.filter(name => name.label.toUpperCase().includes(val))
            this.setState({
                FavYourCatg: e.target.value, autocompleteDataRstl: result
            });
        }


        /**
         * Handle the remote request with the current text !
         */

    }
    CloseSupplierSuggestion = () => {
        window.history.go(-1);
    }
    onSelect(val) {
        this.setState({
            FavYourCatg: val
        });

    }

    //WW-1216 Precart ratings and reviews - Yuvarani K
    PreferredItemCheck = (CartOrFav, value, index, popup) => {
        if (index != 0) {
            ItemDetail = value
            this.setState({ IsReasonPopup: true, currentItemIndex: index, ItemDetail: value })
            $('#ReasonPopup').modal('show');

        }
        else {
            this.AddToCartOrFavClick("Add To Cart", value, this.state.currentItemIndex, "", this.state.ReasonType, this.state.Comments)
        }
    }
    // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
    bindSupplierList = () => {

        if (SuppllierGridArray != undefined && SuppllierGridArray != null && SuppllierGridArray.length > 0) {
            let ChoMfgName = CookieService.getLocalStorageValues("ChosenMFGName");
            let SupplierNameChosen = CookieService.getLocalStorageValues("ChosenSupplier");
            let ChosenID = CookieService.getLocalStorageValues("ChosenItemId");
            let SearchedItem = SuppllierGridArray.filter((val, index) => MFGPartNo.toLowerCase() && val.manufacturer_name.toLowerCase() == ChoMfgName.toLowerCase() && val.supplierName == SupplierNameChosen && val.clientPartNumber.toLowerCase() == ChosenID.toLowerCase());
            return SuppllierGridArray.map((val, index) => {
                ItemID = val.clientPartNumber;
                Vendor_ID = val.vendor_id;
                let classname = "p d-none content-row";
                let accClassname = "accordion-heading";
                if (SearchedItem.length == 0) {
                    if (index == 0) {
                        classname = "p content-row";
                        accClassname = "accordian-close";
                    }
                }
                else if (val.mfg_part_number.toLowerCase() == MFGPartNo.toLowerCase() && val.manufacturer_name.toLowerCase() == ChoMfgName.toLowerCase() && val.supplierName == SupplierNameChosen && val.clientPartNumber.toLowerCase() == ChosenID.toLowerCase()) {
                    classname = "p content-row";
                    accClassname = "accordian-close";
                }
                //else if (index == 0) {
                //    classname = "p content-row";
                //    accClassname = "accordian-close";
                //}
                //if (index == 0) {
                //    classname = "p content-row";
                //}A
                let AddbtnName = "";
                if (IsFromFavClick == "No" || IsFromFavClick == "") {
                    AddbtnName = "Add To Cart";
                }
                else {
                    AddbtnName = "Add To Favorites";
                }
                let hasBentonville = "";
                if (val.actual_qty != undefined && val.actual_qty != null && val.actual_qty != "") {
                    hasBentonville = val.actual_qty.slice(-1);
                }
                let QuantityOnhand = ""
                let QuantityOnhandL = []
                if (val.actual_qty != null && val.actual_qty != undefined) {
                    QuantityOnhandL = val.actual_qty.split('^')
                    if (QuantityOnhandL != null && QuantityOnhandL != undefined) {
                        if (QuantityOnhandL.length > 0) {
                            if (QuantityOnhandL[0] != "Y" && QuantityOnhandL[0] != "y" && QuantityOnhandL[0] != 0) {
                                QuantityOnhand = QuantityOnhandL[0]
                            }
                            else {
                                QuantityOnhand = ""

                            }
                        }
                    }
                }
                if (QuantityOnhand == "") {
                    QuantityOnhand = "-";
                }
                let attributeValue = val.AttributeValue.replace(/\s/g, "");

                return (
                    <div className="card border-0 w-75 mb-2 " id={`Supplierdiv${index}`}>
                        <div className="card-header p-0" id={`supplierheading${index}`} >
                            <h5 className="mb-0 accordion-header filteraccheading open" >
                                <div className="row align-items-center" style={{ "justifyContent": "space-between" }}>
                                    <div className="d-flex align-items-center" >
                                        {val.supplierName}
                                        {val.IsSupplierFav == false ? null :
                                            <span className="fav-item-maintenance-icon d-inline-block">
                                                <input type="checkbox" className="checknow" id={index} checked="true" data-backdrop="static" data-keyboard="false" />
                                                <label htmlFor={index} className="mb-0">
                                                    <svg className="heart-svg heart-icon " viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg" data-backdrop="static" data-keyboard="false">
                                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                            </g>
                                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </label>
                                            </span>
                                        }

                                    </div>
                                    <div className="d-flex align-items-center mr-4">
                                        {val.product_rating == "\\N" || val.rating_count == "\N" ? null :

                                            <span className="catalog-value">{val.product_rating}</span>
                                        }
                                        <span style={{ "marginLeft": "6px", "marginRight": "6px" }}><img style={{ "marginBottom": "3px" }} src={this.getStarImage(val.product_rating)}>
                                        </img> </span>
                                        {val.rating_count == "\\N" || val.rating_count == "\N" ?
                                            <label style={{ "marginLeft": "6px", "marginTop": "6px" }} className="catalog-value"><Trans>No reviews yet</Trans></label> :
                                            <label style={{
                                                "marginLeft": "6px", "marginTop": "6px", "marginRight": "3px"
                                            }} className="catalog-value">({val.rating_count})</label>
                                        }
                                    </div>
                                </div>
                            </h5>

                            <span className={accClassname} id={`accordianicon${index}`} onClick={(e) => this.onAccordianClick(e, index)} />
                        </div>
                        <div id={`collapseOne${index}`} className={classname} data-parent="#accordion">
                            <div className="card-body m-0 p-0 filteracc-body" id="child1">
                                <div className="row justify-content-center">
                                    <div className="col-md-12 mb-2 mt-2">
                                        <div className="col-md-12 float-left">
                                            <label className="info-label col-md-4 p-0 float-left"><Trans>Item ID</Trans></label>
                                            <label className="info-value col-md-8 p-0 float-left">{val.mfg_part_number}{hasBentonville.toUpperCase() == "C" ? <span class="i-circlegridBlue" >C</span> : hasBentonville.toUpperCase() == "T" ? <span class="i-circlegridYellow" >T</span> : val.vendor_id == "W999999999" ? <span class="i-circlegrid" >w</span> : null}</label>

                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-2 mt-2">
                                        <div className="col-md-12 float-left">
                                            <label className="info-label col-md-4 p-0 float-left"><Trans>Supplier</Trans></label>
                                            <label className="info-value col-md-8 p-0 float-left">{val.supplierName}</label>

                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-2 mt-2">
                                        <div className="col-md-12 float-left">
                                            <label className="info-label col-md-4 p-0 float-left"><Trans>Supplier Part#</Trans></label>
                                            <label className="info-value col-md-8 p-0 float-left">{val.clientPartNumber}</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-2">
                                        <div className="col-md-12 float-left">
                                            <label className="info-label col-md-4 p-0 float-left"><Trans>UOM</Trans></label>
                                            <label className="info-value col-md-8 p-0 float-left">{val.UOM}</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-2">
                                        <div className="col-md-12 float-left">
                                            <label className="info-label col-md-4 p-0 float-left"><Trans>Quantity On Hand</Trans></label>
                                            <label className="info-value col-md-8 p-0 float-left">{QuantityOnhand}</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-2">
                                        <div className="col-md-12 float-left">
                                            <label className="info-label col-md-4 p-0 float-left"><Trans>Package Quantity</Trans></label>
                                            <label className="info-value col-md-8 p-0 float-left">{val.package_qty}</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-2">
                                        <div className="col-md-12 float-left">
                                            <label className="info-label col-md-4 p-0 float-left"><Trans>Min Order Quantity</Trans></label>
                                            <label className="info-value col-md-8 p-0 float-left">{val.min_order_qty}</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-2">
                                        <div className="col-md-12 float-left">
                                            <label className="info-label col-md-4 p-0 float-left"><Trans>Ship within</Trans></label>
                                            <label className="info-value col-md-8 p-0 float-left">{val.ships_within}</label>
                                        </div>
                                    </div>

                                    {/*
                                    <div className="col-md-12 mb-2">
                                        <div className="col-md-12 float-left">
                                            <label className="info-label col-md-4 p-0 float-left"><Trans>Price</Trans></label>
                                            <label className="info-value col-md-8 p-0 float-left">{val.cost_price}</label>
                                        </div>
                                    </div>*/}
                                    {AddbtnName == "Add To Cart" ? <div className="col-md-12 mb-2">
                                        <div className="col-md-12 float-left">
                                            <div class="quantity buttons_added" style={{ "marginLeft": "1%", "width": "30%", "float": "left", "marginRight": "15%" }} >
                                                <input type="button" disabled={attributeValue.indexOf('BATTERY') > -1 || attributeValue.indexOf('CHARGER') > -1 || val.QuantityOrdered == val.min_order_qty} value="-" class="minus" style={{ "backgroundColor": "white" }} onClick={(e) => this.handleMinOrderQuantity(e, index, val)} />
                                                <input type="number" disabled={attributeValue.indexOf('BATTERY') > -1 || attributeValue.indexOf('CHARGER') > -1} class="minus" name="quantity" value={val.QuantityOrdered} title="Qty" size="4" id={`quantityid${index}`} style={{ "width": "73%", "borderLeft": "0" }} onChange={(e) => this.handleEditQuantity(e, index, val)} />
                                                <input type="button" disabled={attributeValue.indexOf('BATTERY') > -1 || attributeValue.indexOf('CHARGER') > -1 || val.QuantityOrdered == 99999} value="+" class="plus" style={{ "backgroundColor": "white" }} onClick={(e) => this.handleMinOrderQuantity(e, index, val)} /> {/*21/8/2023, 3966 - changed the max quantity to 99999, Divis Kumar R K*/}
                                            </div>
                                        </div>
                                        <div className="col-md-12 d-sm-flex justify-content-end">
                                            <button className="btn custom-btn-primary custom-image-btn px-3 text-nowrap" onClick={(e) => this.RatingPopup(e, val)} style={{ "marginRight": "14px", "float": "left", "marginTop": "12px" }}><img src="Images/star-icon.svg" alt="star-icon" className="star-icon me-2" style={{ "paddingRight": "7px", "paddingBottom": "2px" }}></img><Trans>Add Review</Trans></button>
                                            <button className="btn custom-btn-primary custom-image-btn px-3  text-nowrap" type="button" style={{ "marginRight": "14px", "float": "left", "marginTop": "12px" }} onClick={(e) => this.PreferredItemCheck(AddbtnName, val, index, "")} ><img src="Images/cart-icon-black.svg" style={{ "marginRight": "7px" }}></img><Trans>{AddbtnName}</Trans></button>
                                        </div>
                                    </div> : null}
                                    {val.minOrderQtyCheck ?
                                        <div class="col-md-12 float-left"><span class="errorspan1 col-md-10 p-0  mt-4 float-left" id="MinOrderQty">Entered quantity must match with the minimum order quantity sequence.</span></div> : null}
                                    {/* <div className="col-md-8 mb-2">
                                        <div className="col-md-12 float-left">
                                            <button className="btn catagoryFilterBtn" type="button" onClick={() => this.AddToCartOrFavClick(AddbtnName, val, index,"")} >{AddbtnName}</button>
                                        </div>
                                    </div>*/}

                                </div>

                            </div>
                        </div>
                    </div>
                );
            });

        }

    }

    render() {
        const {t}=this.props

        return (
            <div className="container-fluid content-section Suppliersugg" id="suppgrid">
                <div className="modal-dialog modal-lg custom-popup modal-dialog-centered" data-backdrop="static" data-keyboard="false">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title mt-1"><Trans>Updated to Walmart Preferred Item(s)</Trans></h4>
                            <button type="button" className="btn close-btn" onClick={() => this.CloseSupplierSuggestion()}>
                                X
                        </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <span className="float-left info-label ">{LongDesc}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center my-5 pt-2">
                            {this.bindSupplierList()}
                        </div>
                    </div>

                </div>

                <div className="modal" id="CoreChargePopUp">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-content d-block"><Trans>The Item you have chosen has a CORE RETURN REQUIREMENT, a CORE Charge fee will be charged at time of purchase and refunded upon return of the associated CORE to the supplier.</Trans></label>
                                        <label className="confirm-content d-block"><Trans>By choosing to PROCEED, You acknowledge that you will ensure the CORE is returned as required!</Trans></label>
                                    </div>{/**(e) => this.CoreChargeProceedClick(e)*/}
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={(e) => this.CoreChargePopUpclose(e)}><Trans>Cancel</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => this.AddToCart(this.state.AddValue, this.state.AddIndex, true)}  ><Trans>Proceed</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="NotanEnersysEmp" data-backdrop="static">
                    <div className="modal-dialog custom-popup modal-dialog-centered" data-backdrop="static">
                        <div className="modal-content" style={{ "marginLeft": "78px" }}>
                            {/* Modal Header */}
                            <div className="modal-header bg-white border-0">
                                <button type="button" className="btn close-btn bg-white" data-dismiss="modal" style={{ "marginLeft": "362px" }}>
                                    X
                                 </button>
                            </div>
                            {/* Modal body */}

                            <div className="text-center my-4">
                                <span className="info-label"><Trans>Replacement batteries are not currently available through Zeus, please consult with your manager or vendor management office (VMO) or order a replacement through service channel via home office realty procurement solutions (RPS) - sorry for any inconvenience this may cause</Trans></span>
                            </div>


                            <div className="col-md-12 text-center mb-2">
                                <button className="btn btn-primary custom-btn-primary primary-btn px-4 mr-2" onClick={e => this.NotAnEnersysyEmp()}>Ok</button>{/*[01/30/22, PC_EF_07, Priyanka.D]*/}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal p-0" id="EnersysEmployee" data-backdrop="static">
                    <div className="modal-dialog custom-popup modal-dialog-centered" data-backdrop="static">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header bg-white border-0">
                                <h4 class="modal-title mt-1"></h4>
                                <button type="button" className="btn close-btn bg-white" data-dismiss="modal">
                                    X
                            </button>
                            </div>
                            {/* Modal body */}

                            <div className="text-center px-4 my-4">
                                <span className="info-label">{this.state.EnersysEmp}</span>
                            </div>


                            <div className="col-md-12 text-right mb-2">
                                <button className="btn btn-secondary custom-btn-custom-btn-secondary secondary-btn mr-2" data-dismiss="modal" onClick={e => this.EnersysyEmp("No")}>No</button>
                                <button className="btn btn-primary custom-btn-primary primary-btn" onClick={e => this.EnersysyEmp("Add to Cart", this.state.AddValue)}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*
                <div className="modal" id="add-fav-popup" data-backdrop="static" data-keyboard="false">

                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                {/* <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Add</Trans><span> </span><Trans>Favorites</Trans></h4>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.CloseFavoritePopup()}>
                                    X
              </button>
                            </div>*/}
                {/* Modal body */}
                {/* <div className="modal-body">
                                <div className="row mt-3">
                                    <div className="col-12 edit-desc-field mb-3">
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>Item ID</Trans></label>
                                            {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                {/* <label className="col-md-7 quick-value" id="FavItemId" >{SuppllierGridArray[0].mfg_part_number}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><span>SDI </span><Trans>Category</Trans></label>
                                            <label className="col-md-7 quick-value" id="FavSDICatg" >{this.state.ItemSDICatagory}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label indicate-alert"><Trans>Your</Trans><span> </span><Trans>Category</Trans></label>

                                            <div className="float-left search-autocomplete col-md-7 home-search" style={{ zIndex: "9999" }}>
                                                <Autocomplete
                                                    getItemValue={this.getItemValue}
                                                    items={this.state.autocompleteDataRstl}
                                                    renderItem={this.renderItem}
                                                    value={this.state.FavYourCatg}
                                                    onChange={e => this.onChange(e)}
                                                    onSelect={e => this.onSelect(e)}
                                                    inputProps={{ placeholder: "Search", className: "form-control float-left" }}
                                                    maxLength="40"
                                                />
                                                <span className="errorspan1" style={{ fontSize: '10px' }} id="favordcatid" />
                                                {this.state.CategoryErr ? <span className=" W-100 errorspan1 text-left " style={{ fontSize: '15px' }}>Enter Category</span> : null}
                                            </div>


                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>Description</Trans></label>
                                            <label className="col-md-7 quick-value" id="FavItemDescrip" >{LongDesc}</label>
                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><Trans>Notes</Trans></label>
                                            <div className="col-md-7">
                                                <textarea className="form-control custom-textarea" id="FavYourDescrip" maxLength="100" rows={5} defaultValue={''} />
                                            </div>
                                        </div>
                                        {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                {/*  <div className="row mb-3">
                                            <label className="col-md-5 quick-label">Manufacturer</label>
                                            <label className="col-md-7 quick-value" id="FavMFG" >{SuppllierGridArray[0].manufacturer_name}</label>
                                        </div>
                                        <div className="row mb-3">
                                            {/*  WW-722 Label Standerization 6/1/2023 Pavithra R */}
                {/*       <label className="col-md-5 quick-label"><span>Supplier </span><Trans>part#</Trans></label>
                                            <label className="col-md-7 quick-value" id="FavMFGPartNUM" >{SuppllierGridArray[0].clientPartNumber}</label>
                                        </div>

                                        <div className="row mb-3">
                                            <label className="col-md-5 quick-label"><span>Choose Your Own image</span><Trans></Trans></label>
                                            <div className="col-md-7 input-group">
                                                <input type="file" title=" " accept="image/jpeg, image/png" style={{ "font-size": "10px" }} id="customFile" name="filename" onChange={this.handleAttachment} onClick={this.onInputClick} />
                                                <label className="custom-file-label mx-3 sdi-font-12" htmlFor="customFile"><Trans>Choose File</Trans></label>
                                                {this.bindAttachments()}
                                                <label className="priority-alert mt-3" id="lblerror">{this.state.lblerror}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4" id="FavSaveBtn" onClick={() => this.AddfavItem(true)}><Trans>save_key</Trans></button>
                                    </div>
                                    <div>
                                        <label id="txtUOMHide" >{this.state.txtUOMHidePopUp}</label>
                                        <label id="txtMfgItemidHide" >{this.state.txtMfgItemidHidePopUp}</label>
                                        <label id="txtItemidHide" >{this.state.txtItemidHidePopUp}</label>
                                        <label id="txtMFGHide" >{this.state.txtMFGHidePopUp}</label>
                                        <label id="ItemType" >{this.state.ItemType}</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                { /*[11/21/2024 Rating popup */}
                <div className="modal" id="RatingPopup">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="">
                                        <p style={{ "fontSize": "large" }}><b><Trans>Please rate this item</Trans></b></p>
                                        <div className="text-center" style={{ "marginBottom": "8px" }}>
                                            <Rating
                                                value={this.state.StarRating}
                                                max={5}
                                                onChange={(value) => this.Rating(value)}
                                            />

                                        </div>



                                        {/*[10/11/22,WW-521-Implementation of Character counter], Priyanka D */}

                                    </div>
                                    <div className="col-md-12">
                                        <textarea className="col-md-12 form-control custom-textarea " id="decreasoncmt" maxLength="254" placeholder={t("Write a review")} style={{ "height": "80px" }} onChange={(e) => this.HandleReview(e)} value={this.state.Review}></textarea>

                                    </div>
                                </div>

                                <div className="col-md-12 text-center mb-2 mt-2">

                                    <span><button className={`btn btn-primary primary-btn px-4 mt-3 ${this.state.StarRating == 0 ? 'CursorAlias' : ''}`} onClick={(e) => this.CloseRatingPopup(e)} style={{ "marginRight": "7px", "borderColor": "gray", "backgroundColor": "gray", "color": "white" }} ><Trans>Cancel</Trans></button></span>

                                    <span> <button className={`btn btn-primary custom-btn-primary primary-btn px-4 mt-3 ${this.state.StarRating == 0 ? 'CursorAlias' : ''}`} disabled={this.state.StarRating == 0} onClick={(e) => this.RatingSubmission(e)}><Trans>Submit</Trans></button></span>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { /*[11/21/2024 Rating popup ends*/}




                { /*[11/21/2024 Reason popup */}
                <div className="modal" id="ReasonPopup">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Please provide the reason for selecting this supplier</Trans></h4>
                                <button type="button" className="btn close-btn" onClick={() => this.CloseReasonPopup()}>
                                    X
                        </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body reason-popup p-4">
                                <label><b><Trans>Reason type</Trans></b></label>
                                <Select style={{
                                    "height": "150px", "overFlow": "auto"
                                }}
                                    id="ReasonDD"
                                    name="Reason"
                                    options={this.state.ReasonList}
                                    classNamePrefix="react-select"
                                    value={this.state.ReasonType}
                                    onChange={(e) => this.HandleReasonType(e)}

                                />



                                <label style={{ "marginTop": "14px" }} ><Trans><b>Comments</b></Trans></label>
                                {this.state.ReasonType.value == "Other" ? <span style={{ "color": "red" }}>* </span> : null}
                                <div className="col-md-12 px-0">
                                    <textarea className="col-md-12 form-control custom-textarea" id="decreasoncmt" maxLength="254" placeholder={t("Enter comments")} style={{ "height": "80px" }} onChange={(e) => this.HandleComments(e)} value={this.state.Comments}></textarea>

                                </div>

                            </div>


                            <div className="col-md-12 d-flex justify-content-end px-4 pb-4">

                                <span><button className={`btn btn-primary primary-btn px-4 mt-3 ${ReasonSelect == false ? 'CursorAlias' : ''}`} onClick={(e) => this.CloseReasonPopup(e)} style={{ "marginRight": "7px", "borderColor": "gray", "backgroundColor": "gray", "color": "white" }} ><Trans>Cancel</Trans></button></span>
                                {/*12/05/2024 Precart SIT-1 bugs - Yuvarani K*/}



                                <span>
                                    <button
                                        className={`btn btn-primary custom-btn-primary primary-btn px-4 mt-3 ${ReasonSelect == false ? 'CursorAlias' : ''}`}
                                        disabled={this.state.ReasonType ? this.state.ReasonType.value != "Other" ? false : this.state.Comments != "" ? false : true : true} onClick={(e) => this.AddToCartOrFavClick("Add To Cart", this.state.ItemDetail, this.state.currentItemIndex, "", this.state.ReasonType, this.state.Comments)}><Trans>Submit</Trans></button></span>

                            </div>
                        </div>
                    </div>
                </div>

                {/*[11/21/2024 Reason popup ends*/}
                <div className="modal" id="add-fav-Img">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Do you want to add Image for this item?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.AddfavItem(true)} ><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.AddToFav("", 0, "Yes")}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
};
export default withTranslation()(SupplierSuggestionComponent);